import React from 'react';
import { costFormater, ErrorModal } from '@common-fe/common-fe';

import { SERVER_ERROR_MODAL_TEXT, SERVER_ERROR_MODAL_TITLE } from '@/common/constants';
import { PendingModal, SuccessModal } from '@/components/elements';

interface Props {
  selectedCount: number;
  selectedAmount: number;
  isConfirmVisible: boolean;
  isSuccessVisible: boolean;
  isErrorVisible: boolean;
  onConfirm: () => void;
  onCloseConfirm: () => void;
  onCloseSuccess: () => void;
  onCloseError: () => void;
}

const ApplyFundsModals: React.FC<Props> = ({
  selectedCount,
  selectedAmount,
  isConfirmVisible,
  isSuccessVisible,
  isErrorVisible,
  onConfirm,
  onCloseConfirm,
  onCloseSuccess,
  onCloseError,
}) => (
  <>
    <PendingModal
      testId="apply-funds_confirm"
      visible={isConfirmVisible}
      header={`Apply ${costFormater(selectedAmount, true)} to ${selectedCount} ${
        selectedCount === 1 ? 'invoice' : 'invoices'
      }?`}
      buttonText="Confirm"
      cancelButtonText="Close"
      buttonsWidth="200px"
      cancelButtonTestId="apply-funds_confirm_cancel"
      submitButtonTestId="apply-funds_confirm_submit"
      onSetVisible={onCloseConfirm}
      onCancel={onCloseConfirm}
      onSubmit={onConfirm}
    />
    <SuccessModal
      testId="apply-funds_success"
      visible={isSuccessVisible}
      header="The funds will be applied shortly"
      buttonText="Go Back"
      onSetVisible={onCloseSuccess}
    />
    <ErrorModal
      testId="apply-funds_error"
      visible={isErrorVisible}
      header={SERVER_ERROR_MODAL_TITLE}
      helpText={SERVER_ERROR_MODAL_TEXT}
      buttonText="Close"
      buttonTextTryAgain="Try again"
      onSetVisible={onCloseError}
      onSubmit={onConfirm}
    />
  </>
);

export default ApplyFundsModals;
